import { Injectable } from '@angular/core';
import { Resolve, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';

import { RoleService } from '../role/role.service';
import { Role } from '../role/role';

@Injectable({ providedIn: 'root'})
export class RoleResolver implements Resolve<Observable<Role[]>>{

    constructor(private service: RoleService) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Role[]> {
        return this.service.findAll();
    }
}